module.exports = __webpack_public_path__ + "static/media/duel.626408ad.png";